import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
        <TopicsSection />
        <FeaturesSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <FaqSection />
        <MediaSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}